module.exports = __webpack_public_path__ + "logo_hisense-55574bbf7bd4533a812c2c2e44fad729.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo_hisense.png
// module id = 1378
// module chunks = 1